export default {
  en: {
    categories: {
      title: 'Product Groups',
      sub: 'Sub Categories',
      compact: 'Compact Tractors',
      utility: 'Utility Tractors',
      agricultural: 'Agricultural Tractors',
      orchard: 'Orchard Tractors',
      vineyard: 'Vineyard Tractors',
      industrial: 'Industrial Tractors'
    },
    filters: {
      title: 'Filters',
      new: 'New Arrivals',
      hot: 'Best Sellers',
      ce: 'CE Certified'
    },
    sort: {
      title: 'Sort By',
      default: 'Default',
      powerAsc: 'Power (Low to High)',
      powerDesc: 'Power (High to Low)',
      newest: 'Newest First'
    },
    details: {
      model: 'Model',
      power: 'Power/HP',
      engine: 'Engine',
      displacement: 'Displacement',
      transmission: 'Transmission',
      wheelbase: 'Wheelbase',
      weight: 'Weight',
      groundClearance: 'Ground Clearance',
      dimensions: 'Dimensions',
      hydraulicSystem: 'Hydraulic System',
      pto: 'PTO',
      features: 'Features',
      description: 'Description',
      specifications: 'Technical Specifications',
      videos: 'Product Videos',
      documents: 'Documents'
    },
    inquiry: {
      title: 'Send Inquiry',
      name: 'Your Name',
      email: 'Email',
      phone: 'Phone/WhatsApp',
      company: 'Company',
      country: 'Country',
      message: 'Message',
      subscribe: 'Subscribe to our newsletter',
      send: 'Send Inquiry',
      required: 'Required field',
      emailInvalid: 'Email must be valid'
    },
    actions: {
      sendInquiry: 'Send Inquiry',
      downloadBrochure: 'Download Brochure',
      close: 'Close',
      retry: 'Retry',
      viewDetails: 'View Details',
      refresh: 'Refresh Data'
    },
    search: {
      placeholder: 'Search Products'
    },
    total: 'Total',
    products: 'Products',
    states: {
      loading: 'Loading products...',
      error: 'Failed to load products',
      noData: 'No products found',
      cached: 'Cached'
    },
    labels: {
      model: 'Model',
      power: 'Power',
      engine: 'Engine',
      transmission: 'Transmission',
      description: 'Description',
      features: 'Features',
      specifications: 'Technical Specifications',
      dimensions: 'Dimensions',
      weight: 'Weight',
      wheelbase: 'Wheelbase',
      groundClearance: 'Ground Clearance',
      hydraulicSystem: 'Hydraulic System',
      pto: 'PTO',
      otherSpecifications: 'Other Specifications',
      customization: 'Customization',
      afterSalesService: 'After-sales Service',
      warranty: 'Warranty',
      deliveryTime: 'Delivery Time',
      contactSupplier: 'Contact Supplier',
      onlineConsultation: 'Online Consultation',
      priceOnRequest: 'Price on Request',
      unit: ' Unit(s)',
      productDetails: 'Product Details',
      categories: 'Categories',
      driveType: 'Drive Type',
      usage: 'Usage',
      fuel: 'Fuel',
      displacement: 'Displacement',
      months: 'Months',
      days: 'Days',
      minOrder: 'Min. Order',
      productDescription: 'Product Description',
      basicInfo: 'Basic Information',
      standardEquipment: 'Standard Equipment',
      options: 'Options',
      tractorSpecs: 'Tractor Specifications',
      loaderSpecs: 'Front End Loader Specifications',
      backhoeSpecs: 'Backhoe Specifications',
      packagingDelivery: 'Packaging & Delivery',
      // Basic info labels
      modelNo: 'Model No.',
      certification: 'Certification',
      emissionStandard: 'Emission Standard',
      serviceLife: 'Service Life',
      size: 'Size',
      color: 'Color',
      condition: 'Condition',
      transmissionType: 'Transmission Type',
      frontWheel: 'Front Wheel',
      farmingTools: 'Farming Tools',
      transportPackage: 'Transport Package',
      option: 'Option',
      trademark: 'Trademark',
      specification: 'Specification',
      productionCapacity: 'Production Capacity',
      origin: 'Origin',
      // Dimension labels
      length: 'Length (to front ballast)',
      width: 'Width',
      height: 'Height (to the exhaust vent)',
      wheelbaseTitle: 'Wheelbase',
      frontTrack: 'Front Track',
      rearTrack: 'Rear Track',
      structureWeight: 'Structure Weight',
      // Engine specs
      engineTitle: 'Engine',
      engineModel: 'Model',
      engineType: 'Type',
      ratedPower: 'Rated Power(kw)',
      ratedSpeed: 'Rated Speed(r/min)',
      fuelType: 'Fuel',
      // Tire specs
      tireTitle: 'Tires',
      frontTire: 'Front Tire',
      rearTire: 'Rear Tire',
      // Other specs
      clutch: 'Clutch',
      steering: 'Steering',
      suspensionType: 'Suspension Type',
      ptoTypeAndRev: 'PTO Type and Rev',
      splineSize: 'Spline Size',
      // Loader specs
      bucketCapacity: 'Bucket Capacity',
      ratedLoad: 'Rated Load',
      overallDimension: 'Overall Dimension',
      maxDumpHeight: 'Max. Dump Height',
      maxDumpDistance: 'Max. Dump Distance',
      maxRollbackAngle: 'Max. Rollback Angle',
      maxDumpingAngle: 'Max. Dumping Angle',
      maxScrapingAngle: 'Max. Scraping Angle',
      liftingTime: 'Lifting Time',
      descendingTime: 'Descending Time',
      recommendedTraction: 'Recommended Traction',
      // Backhoe specs
      backhoeModel: 'Model',
      bucketWidth: 'Bucket Width',
      maxDiggingDepth: 'Max. Digging Depth',
      maxDiggingRadius: 'Max. Digging Radius',
      maxDiggingHeight: 'Max. Digging Height',
      dischargingHeight: 'Discharging Height',
      maxDiggingDepthFlat: 'Max. Digging Depth (Flat Bottom)',
      swingAngle: 'Swing Angle',
      bucketRotationAngle: 'Bucket Rotation Angle',
      ripperStick: 'Ripper Stick',
      operatingPressure: 'Operating Pressure',
      // Packaging
      packagingNote1: 'Units made 1x40\'ft assembled',
      packagingNote2: 'Delivery time: 30 days after receiving your deposit',
      // Company info labels
      companyInfo: 'Company Information',
      companyProfile: 'Company Profile',
      companyName: 'Company Name',
      businessType: 'Business Type',
      mainProducts: 'Main Products',
      employeeCount: 'Employee Count',
      yearEstablished: 'Year Established',
      certifications: 'Certifications',
      exportMarkets: 'Export Markets',
      factorySize: 'Factory Size',
      companyAdvantages: 'Company Advantages',
      rdCapability: 'R&D Capability',
      productionCapability: 'Production Capability',
      qualityControl: 'Quality Control'
    },
    values: {
      usage: 'Agricultural Tractor, Garden Tractor',
      fuel: 'Diesel',
      customizationSupported: 'Supported',
      afterSalesService: 'Free Parts/Online Support',
      manufacturer: 'Manufacturer',
      companyName: 'Fuhai Tongda International Machinery (Suzhou) Co., Ltd.',
      mainProducts: 'Agricultural Tractors, Garden Tractors, Compact Tractors',
      exportMarkets: 'Global Markets including Europe, Americas, Asia, Africa',
      rdCapability: 'Professional R&D team with over 20 years experience in tractor design and manufacturing',
      productionCapability: 'Annual production capacity of 50,000 units with modern assembly lines',
      qualityControl: 'Strict quality control system with ISO9001 certification and 100% testing before delivery'
    }
  },
  zh: {
    categories: {
      title: '产品分类',
      sub: '子分类',
      compact: '小型拖拉机',
      utility: '多用途拖拉机',
      agricultural: '农用拖拉机',
      orchard: '果园拖拉机',
      vineyard: '葡萄园拖拉机',
      industrial: '工业拖拉机'
    },
    filters: {
      title: '筛选',
      new: '新品',
      hot: '热销',
      ce: 'CE认证'
    },
    sort: {
      title: '排序方式',
      default: '默认排序',
      powerAsc: '按功率升序',
      powerDesc: '按功率降序',
      newest: '最新发布'
    },
    details: {
      model: '型号',
      power: '功率/马力',
      engine: '发动机',
      displacement: '排量',
      transmission: '变速箱',
      wheelbase: '轴距',
      weight: '整机重量',
      groundClearance: '最小离地间隙',
      dimensions: '外形尺寸',
      hydraulicSystem: '液压系统',
      pto: '动力输出轴',
      features: '产品特点',
      description: '产品描述',
      specifications: '技术参数',
      videos: '产品视频',
      documents: '相关文档'
    },
    inquiry: {
      title: '发送询盘',
      name: '姓名',
      email: '邮箱',
      phone: '电话/WhatsApp',
      company: '公司',
      country: '国家/地区',
      message: '留言',
      subscribe: '订阅我们的新闻',
      send: '发送询盘',
      required: '必填项',
      emailInvalid: '请输入有效的邮箱地址'
    },
    actions: {
      sendInquiry: '发送询盘',
      downloadBrochure: '下载产品手册',
      close: '关闭',
      retry: '重试',
      viewDetails: '查看详情',
      refresh: '刷新数据'
    },
    search: {
      placeholder: '搜索产品'
    },
    total: '总计',
    products: '产品',
    states: {
      loading: '正在加载产品...',
      error: '加载产品失败',
      noData: '未找到产品',
      cached: '已缓存'
    },
    labels: {
      model: '型号',
      power: '功率',
      engine: '发动机',
      transmission: '变速箱',
      description: '描述',
      features: '产品特点',
      specifications: '技术参数',
      dimensions: '外形尺寸',
      weight: '整机重量',
      wheelbase: '轴距',
      groundClearance: '最小离地间隙',
      hydraulicSystem: '液压系统',
      pto: '动力输出轴',
      otherSpecifications: '其他技术参数',
      customization: '定制',
      afterSalesService: '售后服务',
      warranty: '保修期',
      deliveryTime: '发货时间',
      contactSupplier: '联系供应商',
      onlineConsultation: '在线咨询',
      priceOnRequest: '价格面议',
      unit: '台',
      productDetails: '产品详情',
      categories: '产品分类',
      driveType: '驱动方式',
      usage: '用途',
      fuel: '燃料',
      displacement: '排量',
      months: '个月',
      days: '天',
      minOrder: '起订量',
      productDescription: '产品描述',
      basicInfo: '基础信息',
      standardEquipment: '标准配置',
      options: '选配',
      tractorSpecs: '拖拉机规格',
      loaderSpecs: '前铲装载机规格',
      backhoeSpecs: '挖掘机规格',
      packagingDelivery: '包装和发货',
      // Basic info labels
      modelNo: '型号',
      certification: '认证',
      emissionStandard: '排放标准',
      serviceLife: '使用寿命',
      size: '尺寸',
      color: '颜色',
      condition: '状态',
      transmissionType: '变速箱类型',
      frontWheel: '前轮',
      farmingTools: '配套工具',
      transportPackage: '运输包装',
      option: '选配',
      trademark: '商标',
      specification: '规格',
      productionCapacity: '生产能力',
      origin: '产地',
      // Dimension labels
      length: '长度(至前配重)',
      width: '宽度',
      height: '高度(至排气管)',
      wheelbaseTitle: '轴距',
      frontTrack: '前轮距',
      rearTrack: '后轮距',
      structureWeight: '整机重量',
      // Engine specs
      engineTitle: '发动机',
      engineModel: '型号',
      engineType: '类型',
      ratedPower: '额定功率(kw)',
      ratedSpeed: '额定转速(r/min)',
      fuelType: '燃料',
      // Tire specs
      tireTitle: '轮胎',
      frontTire: '前轮',
      rearTire: '后轮',
      // Other specs
      clutch: '离合器',
      steering: '转向',
      suspensionType: '悬挂类型',
      ptoTypeAndRev: 'PTO类型和转速',
      splineSize: '花键尺寸',
      // Loader specs
      bucketCapacity: '铲斗容量',
      ratedLoad: '额定载重',
      overallDimension: '外形尺寸',
      maxDumpHeight: '最大倾卸高度',
      maxDumpDistance: '最大倾卸距离',
      maxRollbackAngle: '最大回转角度',
      maxDumpingAngle: '最大卸载角度',
      maxScrapingAngle: '最大刮平角度',
      liftingTime: '提升时间',
      descendingTime: '下降时间',
      recommendedTraction: '建议牵引力',
      // Backhoe specs
      backhoeModel: '型号',
      bucketWidth: '铲斗宽度',
      maxDiggingDepth: '最大挖掘深度',
      maxDiggingRadius: '最大挖掘半径',
      maxDiggingHeight: '最大挖掘高度',
      dischargingHeight: '卸载高度',
      maxDiggingDepthFlat: '最大挖掘深度(平底)',
      swingAngle: '回转角度',
      bucketRotationAngle: '铲斗回转角度',
      ripperStick: '破碎力',
      operatingPressure: '工作压力',
      // Packaging
      packagingNote1: '台装入40尺集装箱',
      packagingNote2: '发货时间：收到定金后30天',
      // Company info labels
      companyInfo: '公司信息',
      companyProfile: '公司简介',
      companyName: '公司名称',
      businessType: '企业类型',
      mainProducts: '主营产品',
      employeeCount: '员工人数',
      yearEstablished: '成立年份',
      certifications: '认证资质',
      exportMarkets: '出口市场',
      factorySize: '工厂面积',
      companyAdvantages: '企业优势',
      rdCapability: '研发能力',
      productionCapability: '生产能力',
      qualityControl: '质量控制'
    },
    values: {
      usage: '农用拖拉机, 园林拖拉机',
      fuel: '柴油',
      customizationSupported: '支持定制',
      afterSalesService: '免费配件/在线支持',
      manufacturer: '制造商',
      companyName: '福海通达国际机械（苏州）有限公司',
      mainProducts: '农用拖拉机、园林拖拉机、小型拖拉机',
      exportMarkets: '全球市场，包括欧洲、美洲、亚洲、非洲',
      rdCapability: '专业研发团队，拥有20多年拖拉机设计和制造经验',
      productionCapability: '现代化装配线，年产能5万台',
      qualityControl: '严格的质量控制体系，ISO9001认证，出厂前100%检测'
    }
  }
} 